import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/user-selector-v1/user-selector-v1-index';

@Injectable({
    providedIn: 'root'
})
export class UserSelectorV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'user-selector-v1';
    menuTitle: string = "User Selector";
    deprecated: boolean = false;
    /**
     * 
     * @param position the position of the new field to create
     * @returns an isntance of this field with the default data set and new uuid    v4
     */
    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsUserSelectorV1Field(this.type, position);
    }

    /**
     * 
     * @param field the field data we got from database
     * @returns an isntance of this field with the data from database set
     */
    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsUserSelectorV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsUserSelectorV1FieldComponent> {
        return fieldComponents.SettingsUserSelectorV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillUserSelectorV1FieldComponent> {
        return fieldComponents.FillUserSelectorV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewUserSelectorV1FieldComponent> {
        return fieldComponents.ViewUserSelectorV1FieldComponent;
    }


    /**
      * 
      * @param field the object data of the field
      * @returns UserSelectorV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.UserSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsUserSelectorV1Field(this.type, 0);
        // }
    }
}

